var m = require('mithril');
var Choices = require('choices.js');
var baseStyles = require('choices.js/assets/styles/css/choices.min.css');
var nrTheme = require('../../stylesheets/vendor/choices.css');
var key = require('../libs/keybindings');

//choices component (assumes both jQuery and choices are included in the page)

/** @namespace */
var choices = {};

function destroyChoices(ctrl) {
    if (!ctrl.choicesObject || typeof ctrl.choicesObject.destroy !== 'function') {
        return;
    }
    ctrl.choicesObject.destroy();
    ctrl.choicesObject = null;
}

function removeInputHandlers(ctrl) {
    if (!Array.isArray(ctrl.inputElements)) {
        return;
    }
    ctrl.inputElements.forEach(function (input) {
        input.removeEventListener('focus', ctrl.handleFocus);
        input.removeEventListener('blur', ctrl.handleBlur);
    });
    ctrl.inputElements = [];
}

/**
choices config factory. The params in this doc refer to properties of the `ctrl` argument
@param {Object} data - the data with which to populate the <option> list
@param {number} value - the id of the item in `data` that we want to select
@param {function(Object id)} onchange - the event handler to call when the selection changes.
    `id` is the the same as `value`
*/
choices.oncreate = function(vnode) {
    var ctrl = this;
    ctrl.isMultiple = vnode.attrs.multiple !== false;
    ctrl.allowCustomValue = vnode.attrs.allowCustomValue === true;
    var config = {
        removeItemButton: vnode.attrs.disabled && vnode.attrs.disabled == true ? false : true,  
        placeholder: true, 
        placeholderValue: vnode.attrs.disabled && vnode.attrs.disabled == true ? 
                ' ' 
            : 
                vnode.attrs.placeholderValue ? vnode.attrs.placeholderValue : 'Click to Add',
        removeItems: vnode.attrs.disabled && vnode.attrs.disabled == true ? false : true,
        addItems: vnode.attrs.disabled && vnode.attrs.disabled == true ? false : true,
        maxItemCount: ctrl.isMultiple ? -1 : 1,
        classNames: {
            containerInner: vnode.attrs.containerInnerClass ? vnode.attrs.containerInnerClass : 'choices__inner',

        }
    };
    if (typeof vnode.attrs.searchResultLimit === 'number') {
        config.searchResultLimit = vnode.attrs.searchResultLimit;
    }
    if (typeof vnode.attrs.renderChoiceLimit === 'number') {
        config.renderChoiceLimit = vnode.attrs.renderChoiceLimit;
    }
    //set up choices (only if not initialized already)
    ctrl.choicesObject = new Choices(vnode.dom, config);
    ctrl.hasChoiceValue = function (value) {
        if (!Array.isArray(vnode.attrs.data) || value === null || typeof value === 'undefined') {
            return false;
        }
        var normalized = String(value).trim();
        return vnode.attrs.data.some(function (item) {
            return item && item.value !== undefined && item.value !== null && String(item.value).trim() === normalized;
        });
    };
    ctrl.commitCustomValue = function (rawValue) {
        if (!ctrl.allowCustomValue) return;
        if (typeof rawValue === 'undefined' || rawValue === null) return;
        var value = String(rawValue).trim();
        if (!value) return;
        var current = ctrl.choicesObject.getValue(true);
        if (Array.isArray(current) ? current.indexOf(value) > -1 : current === value) {
            return;
        }
        if (ctrl.hasChoiceValue(value)) {
            ctrl.choicesObject.setValueByChoice(value);
        } else {
            ctrl.choicesObject.setValue([value]);
        }
        if (typeof vnode.attrs.value == "function") {
            vnode.attrs.value(value);
            if(vnode.attrs.onchange && typeof vnode.attrs.onchange == "function") vnode.attrs.onchange();
        }
        if (typeof ctrl.choicesObject.clearInput === 'function') {
            ctrl.choicesObject.clearInput();
        }
    };
    //this event handler updates the controller when the view changes
    ctrl.handleChange = function () {
        // Trigger a redraw because Choices events bypass Mithril's auto-redraw.
        if (typeof vnode.attrs.value == "function") {
            var selected = ctrl.choicesObject.getValue(true);
            if (!ctrl.isMultiple && Array.isArray(selected)) {
                selected = selected.length ? selected[0] : '';
            }
            vnode.attrs.value(selected);
            if (vnode.attrs.onchange && typeof vnode.attrs.onchange == "function") {
                vnode.attrs.onchange(selected);
            }
        }
        m.redraw();
    };

    ctrl.syncValueFromAttr = function () {
        if (!ctrl.choicesObject) return;
        var rawValue = typeof vnode.attrs.value === 'function' ? vnode.attrs.value() : vnode.attrs.value;
        var isMultiple = ctrl.isMultiple;
        var nextValues = [];
        var nextValue = '';

        if (isMultiple) {
            if (Array.isArray(rawValue)) {
                nextValues = rawValue;
            } else if (typeof rawValue === 'string' && rawValue.length > 0) {
                nextValues = [rawValue];
            } else if (rawValue != null) {
                nextValues = [String(rawValue)];
            }
            nextValues = nextValues
                .map(function (value) { return typeof value === 'string' ? value.trim() : String(value); })
                .filter(function (value) { return value !== ''; });
        } else {
            if (rawValue === null || typeof rawValue === 'undefined') {
                nextValue = '';
            } else if (typeof rawValue === 'string') {
                nextValue = rawValue.trim();
            } else {
                nextValue = String(rawValue);
            }
        }

        var currentValue = ctrl.choicesObject.getValue(true);

        if (isMultiple) {
            var currentValues = Array.isArray(currentValue) ? currentValue : [currentValue];
            currentValues = currentValues
                .map(function (value) { return typeof value === 'string' ? value.trim() : String(value); })
                .filter(function (value) { return value !== ''; });

            if (currentValues.length === nextValues.length && currentValues.every(function (value) { return nextValues.indexOf(value) > -1; })) {
                return;
            }

            ctrl.choicesObject.removeActiveItems();
            nextValues.forEach(function (value) {
                if (ctrl.hasChoiceValue(value)) {
                    ctrl.choicesObject.setValueByChoice(value);
                } else {
                    ctrl.choicesObject.setValue([value]);
                }
            });
            return;
        }

        if ((currentValue || '').toString().trim() === nextValue) {
            return;
        }

        ctrl.choicesObject.removeActiveItems();
        if (nextValue) {
            if (ctrl.hasChoiceValue(nextValue)) {
                ctrl.choicesObject.setValueByChoice(nextValue);
            } else {
                ctrl.choicesObject.setValue([nextValue]);
            }
        }
    };

    vnode.dom.addEventListener('change', ctrl.handleChange);

    //update the view with the latest controller value
    ctrl.syncValueFromAttr();
    // helper: determine if this input lives inside the modal overlay
    ctrl.isInModal = function () {
        if (!ctrl.inputElement) return false;
        if (typeof ctrl.inputElement.closest === 'function') {
            return !!ctrl.inputElement.closest('#modal-id-to-focus');
        }
        // Fallback for environments without Element.closest
        var el = ctrl.inputElement;
        while (el) {
            if (el.id === 'modal-id-to-focus') return true;
            el = el.parentElement;
        }
        return false;
    };

    ctrl.handleFocus = function () {
        // Only change scope when not inside a modal
        if (!ctrl.isInModal()) {
            key.setScope('modal');
        }
    };

    ctrl.handleBlur = function (ev) {
        if (ctrl.allowCustomValue && ev && ev.target) {
            ctrl.commitCustomValue(ev.target.value);
        }
        // Only reset scope when not inside a modal
        if (!ctrl.isInModal()) {
            key.deleteScope('modal');
            key.setScope('home');
        }
    };
 
    ctrl.inputElements = Array.prototype.slice.call(document.querySelectorAll('.choices__input.choices__input--cloned'));
    ctrl.inputElements.forEach(function (input) {
        input.addEventListener('focus', ctrl.handleFocus);
        input.addEventListener('blur', ctrl.handleBlur);
    });
}

choices.onbeforeremove = function () {
    destroyChoices(this);
}

choices.onremove = function (vnode) {
    vnode.dom.removeEventListener('change', this.handleChange);
    removeInputHandlers(this);
    destroyChoices(this);
}

choices.onupdate = function(vnode){
    var ctrl = this;
    if (typeof ctrl.syncValueFromAttr === 'function') {
        ctrl.syncValueFromAttr();
    }
}

//this view implements choices's `<select>` progressive enhancement mode
choices.view = function(vnode) {
    var ctrl = this;
    return m("select", {multiple:"multiple"}, [
        vnode.attrs.data.map(function(item) {
            return m("option", {value: item.value}, item.key);
        })
    ]);
};

//end component

module.exports = choices;
